import { render, staticRenderFns } from "./BannersFormPage.vue?vue&type=template&id=2978c398&"
import script from "./BannersFormPage.vue?vue&type=script&lang=js&"
export * from "./BannersFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports